module.exports = __webpack_public_path__ + "img/5.de8157c5.webp";